import React, { useState, useEffect } from 'react';
import './index.m.css';
import { FAQ_SECTION_HEADING } from "../../../../constants";
import { PlusIcon, MinusIcon } from "./icons";

const getEmbedUrl = (url) => {
  if (!url) return null;
  if (url.includes('youtube.com/watch?v=')) {
    return url.replace('watch?v=', 'embed/');
  }
  if (url.includes('youtu.be/')) {
    return url.replace('youtu.be/', 'youtube.com/embed/');
  }
  return url;
};

const FaqItem = ({ faq }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [renderVideo, setRenderVideo] = useState(false);

  useEffect(() => {
    let timeout;
    if (isOpen) {
      setRenderVideo(true);
    } else {
      timeout = setTimeout(() => setRenderVideo(false), 300); // 300ms matches the CSS transition
    }
    return () => clearTimeout(timeout);
  }, [isOpen]);

  return (
    <div styleName="faqItem">
      <button 
        styleName="faqToggle" 
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-controls={faq.id}
      >
        <span styleName="faqQuestion" dangerouslySetInnerHTML={{ __html: faq.question }} />
        <span styleName="faqIcon">
          {isOpen ? <MinusIcon /> : <PlusIcon />}
        </span>
      </button>
      
      <div 
        id={faq.id} 
        styleName={`faqAnswerContainer ${isOpen ? 'open' : ''}`}
      >
        <div styleName="faqAnswerContent">
          <div 
            styleName="faqAnswerText" 
            dangerouslySetInnerHTML={{ __html: faq.answer }} 
          />
          {faq.image && (
            <img 
              src={faq.image} 
              width={faq.imageWidth && !String(faq.imageWidth).includes('%') ? faq.imageWidth : undefined} 
              height={faq.imageHeight && !String(faq.imageHeight).includes('%') ? faq.imageHeight : undefined} 
              alt="" 
              styleName="faqImage"
              style={{
                width: faq.imageWidth && String(faq.imageWidth).includes('%') ? faq.imageWidth : undefined,
                height: faq.imageHeight && String(faq.imageHeight).includes('%') ? faq.imageHeight : undefined
              }}
            />
          )}
          {faq.isvideo && (
            faq.videoWidth ? (
              <iframe 
                src={renderVideo ? getEmbedUrl(faq.isvideo) : ""} 
                title="FAQ Video" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
                width={faq.videoWidth && !String(faq.videoWidth).includes('%') ? faq.videoWidth : undefined}
                height={faq.videoHeight && !String(faq.videoHeight).includes('%') ? faq.videoHeight : undefined}
                styleName="faqVideoFixed"
                style={{
                  width: faq.videoWidth && String(faq.videoWidth).includes('%') ? faq.videoWidth : undefined,
                  height: faq.videoHeight && String(faq.videoHeight).includes('%') ? faq.videoHeight : undefined
                }}
              ></iframe>
            ) : (
              <div styleName="faqVideoContainer">
                <iframe 
                  src={renderVideo ? getEmbedUrl(faq.isvideo) : ""} 
                  title="FAQ Video" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                  styleName="faqVideo"
                ></iframe>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export const FaqSection = ({ data = {} }) => {
  const categories = data.faqCategories || [];

  if (!categories || categories.length === 0) return null;

  return (
    <section styleName="faqSectionWrapper" aria-label="FAQ">
      <h2 styleName="sectionHeading">{FAQ_SECTION_HEADING}</h2>
      
      <div styleName="faqCategoriesContainer">
        {categories.map((cat, idx) => (
          <div key={idx} styleName="faqCategory">
            <h3 styleName="categoryHeading">{cat.categoryTitle}</h3>
            <div styleName="faqList">
              {cat.faqs.map(faq => (
                <FaqItem key={faq.id} faq={faq} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
